import React from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";

import { connect } from "react-redux";
import { Input } from "expano-components";
import { createPropertyOption } from "actions/properties";

import { ReactComponent as ApproveIcon } from "icons/approve.svg";
import { ReactComponent as DeclineIcon } from "icons/decline.svg";

const InputField = (props) => <Input {...props} />;

const PropertyOptionNew = ({
  id,
  handleSubmit,
  handleClose,
  langs,
  createPropertyOption,
}) => {
  const onSubmit = (values) =>
    createPropertyOption({
      ...values,
      property_id: id,
    })
      .then(() => handleClose())
      .catch((err) => {
        throw new SubmissionError(err);
      });

  return (
    <>
      <tr className="property-options__form property-options__form--add">
        <td colSpan={langs.length + 1}>
          <p>Jeśli to stała wartość (np. 10 mm), dodaj ją w języku PL i DE, a system sam przekopiuje do pozostałych języków. W przeciwnym razie dodaj tylko PL, a system przetłumaczy na pozostałe języki.</p>
        </td>
      </tr>
      <tr className="property-options__form property-options__form--add">
        {langs.map(({ code }) => (
          <td
            key={code}
            style={{
              verticalAlign: "top",
              paddingRight: "12px",
            }}
          >
            <Field name={`value_${code}`} component={InputField} />
          </td>
        ))}
        <td
          style={{
            verticalAlign: "middle",
            whiteSpace: "nowrap",
            width: "1%",
          }}
        >
          <button
            type="button"
            className="btn btn-icon"
            onClick={handleSubmit(onSubmit)}
          >
            <ApproveIcon />
          </button>
          <button type="button" className="btn btn-icon" onClick={handleClose}>
            <DeclineIcon />
          </button>
        </td>
      </tr>
    </>
  );
};

export default connect(null, (dispatch) => ({
  createPropertyOption: (data) => dispatch(createPropertyOption(data)),
}))(reduxForm({ form: "create-property-option" })(PropertyOptionNew));
